import { createSelector } from 'reselect'

const getForgotPasswordState = state => state.ForgotPassword.forgot
const getForgotPasswordRequestState = state => state.ForgotPassword.request

const isEmailSentSuccessfully = createSelector(
  [getForgotPasswordState],
  state => state.success
)

export { isEmailSentSuccessfully, getForgotPasswordRequestState }
